const variantName = 'menuV1b'

export default {
  [variantName]: {
    // ?============================
    // ?======  Containers =========
    // ?============================
    container: {
      justifyContent: 'center',
      width: '100%',
      padding: ['1rem', '', '2rem'],
      maxWidth: '1200px',
      margin: '0 auto 2rem',
    },

    // ?============================
    // ?========  Buttons  =========
    // ?============================

    backToMenuBtn: {
      backgroundColor: 'primary',
      color: 'white',
      border: 'none',
      marginLeft: '0.5rem',
      cursor: 'pointer',
      justifyContent: 'center',
      paddingBottom: 'calc(0.5rem - 1px)',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingTop: 'calc(0.5rem - 1px)',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },

    // ?============================
    // ?========  Images  ==========
    // ?============================

    imageFill: {
      paddingBottom: '100%', // * reuseable to make images square
    },

    // ?================================
    // ?===========  TABS  =============
    // ?================================

    tabsRow: {
      display: 'flex',
      flexWrap: 'wrap',
      overflow: 'scroll',
      padding: '20px 0',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      justifyContent: ['', '', '', 'center'],
      '.sectionTab': {
        margin: '10px',
      },
    },

    // ?================================
    // ?=========  ALL IN  =============
    // ?================================

    allInContainerWrapper: {
      backgroundSize: 'cover',
      backgroundRepeat: 'none',
      backgroundColor: 'secondary',
      borderRadius: '10px',
      padding: '1rem',
    },
    allInContainer: {},

    menuContainer: {},

    // ?================================
    // ?=========  CELLS  ==============
    // ?================================

    cellContainer: {
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },

    sectionCell: {
      cursor: 'pointer',
      width: [
        '100%',
        'calc(50% - (1rem * 2))',
        'calc(33.333% - (1rem * 2))',
        'calc(33% - (1rem * 2))',
      ],
      backgroundColor: 'backgroundSecondary',
      borderRadius: '10px',
      margin: ['1rem 0', '1rem'],
      boxShadow: (theme) => `2px 2px 2px ${theme.colors.background}`,
      position: 'relative',
    },

    menuCell: {
      flexWrap: 'wrap',
      borderRadius: '10px',
    },
    cellImageContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },

    cellImage: {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    cellName: {
      padding: '1rem',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      textTransform: 'uppercase',
      color: 'light',
      width: '100%',
      textAlign: 'center',
      textShadow: '2px 2px 5px black',
    },

    // ?================================
    // ?========  Menu Sections ========
    // ?================================

    menuSectionTitle: {
      fontSize: '2rem',
      textAlign: 'center',
      margin: '2rem 0',
      color: 'text',
      backgroundColor: 'primary',
      padding: 1,
    },
    menuSectionDescription: {
      textAlign: 'center',
      color: 'dark',
      marginBottom: '1.5rem',
      fontWeight: '500',
    },
    menuItemsContainer: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
    },

    // ?================================
    // ?========  Menu Items ===========
    // ?================================

    // === Menu item
    menuItemContainer: {
      display: 'flex',
      overflow: 'hidden',
      width: ['100%', '', 'calc(50% - (1rem * 2))'],
      marginBottom: '1rem',
      margin: ['', '', '1rem'],
    },

    menuItemContainerImgActive: {
      marginBottom: '1rem',
      margin: ['', '0.5rem'],
      display: 'flex',
      overflow: 'hidden',
      width: [
        '100%',
        'calc(50% - (0.5rem * 2))',
        'calc(33.333% - (0.5rem * 2))',
        'calc(25% - (0.5rem * 2))',
      ],
    },
    menuItemInnerContainer: {
      marginBottom: '1rem',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      color: 'dark',
    },

    // ?================================
    // ?======  Menu Item Image  =======
    // ?================================

    menuItemImageContainer: {
      borderRadius: '10px 10px 0 0',
      position: 'relative',
      cursor: 'pointer',
    },
    menuItemImg: {
      objectFit: 'cover',
      position: 'absolute',
      top: '0px',
      width: '100%',
      height: '100%',
      left: '0px',
      cursor: 'pointer',
    },

    // ?================================
    // ?=====  Menu Item Content  ======
    // ?================================
    menuItemContentContainer: {
      padding: '0px',
      height: '100%',
      flexDirection: 'column',
      margin: '1rem 0rem',
      position: 'relative',
    },
    menuItemNamePriceContainer: {
      alignItems: 'flex-start',
      marginBottom: 1,
    },
    menuItemName: {
      fontSize: '1.25rem',
      fontWeight: 'bolder',
      margin: '0px',
      textTransform: 'uppercase',
    },
    menuItemDescription: {
      whiteSpace: 'break-spaces',
      textTransform: 'capitalize',
      fontWeight: '500',
      width: '90%',
    },

    // ?================================
    // ?======  Menu Items Price =======
    // ?================================

    menuPriceContainer: {
      flexGrow: '1',
      fontSize: '1.5rem',
      justifyContent: 'flex-end',
      position: 'relative',
    },

    variantContainerFloatTopRight: {
      position: 'absolute',
      right: '0rem',
      top: '0rem',
    },

    menuItemPrice: {
      margin: '0px',
      textAlign: 'right',
      minWidth: '2rem',
      fontSize: '1.25rem',
    },

    // ?================================
    // ?======= Section Dropdown =======
    // ?================================

    menuSectionsDropDownContainer: {
      backgroundColor: 'rgba(0,0,0,0.75)',
      borderRadius: '10px',
      position: 'absolute',
      zIndex: '100',
      width: '95%',
      margin: '0 2.5%',
      display: 'flex',
      justifyContent: 'center',
      div: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '1rem',
        borderRadius: '4px',
        margin: 'auto',
        justifyContent: 'center',
      },
    },

    dropdownSection: {
      width: ['calc(50% - (0.5rem * 2))', 'calc(33.33% - (0.5rem * 2))'],
      margin: '0.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      cursor: 'pointer',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '1.25rem',
      span: {
        '&:hover': {
          textDcoration: 'underline',
        },
      },
    },

    // ?================================
    // ?========== Empty Menu  =========
    // ?================================

    noItemsContainer: {
      width: '100%',
      minHeight: '30vh',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}
